import { DatePicker, ESelectModalType, SelectModal } from '@globalmed/atlas-ui';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TFormBuilderDateField, TFormBuilderPreviewModeSize } from '@/types';
import { getDateByString } from '@/utils/convertDate';

type TProps = {
  field: TFormBuilderDateField;
  modeSize: TFormBuilderPreviewModeSize;
};

/**
 * Preview component for date field in form builder
 * @param props - Component props
 * @param props.field - Date field data to preview
 * @param props.modeSize - Preview mode size ('mobile' or 'desktop') to control the display format
 * @returns Form builder date preview component
 */
export const FormBuilderPreviewDate = ({ field, modeSize }: TProps) => {
  const [value, setValue] = useState('');
  const isSmallScreen = useMediaQuery('(max-width: 576px)');
  const isMobile = modeSize === 'mobile' || isSmallScreen;
  return isMobile ? (
    <SelectModal
      type={ESelectModalType.DatePicker}
      labelProps={field}
      selected={value ? dayjs(value).format('L') : ''}
      onChange={(rawValue: string | string[]) => {
        const inputValue = Array.isArray(rawValue)
          ? (rawValue[0] ?? '')
          : rawValue;
        const date = getDateByString(inputValue);
        setValue(date?.toISOString() ?? '');
      }}
      sx={{ maxWidth: '343px' }}
      width="100%"
    />
  ) : (
    <DatePicker
      sx={{ maxWidth: '343px' }}
      value={value ? dayjs(value).toDate() : null}
      onChange={(date) => setValue(date ? date.toISOString() : '')}
      label={field.label}
      required={field.required}
      yearsRange={[1900, new Date().getFullYear() + 1]}
    />
  );
};
